import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatDividerModule } from '@angular/material/divider'
import { NgxMaskDirective } from 'ngx-mask'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { emailValidator } from '../../../shared/utils/email_validator'
import moment from 'moment/moment'
import { cpfValidator } from '../../../shared/utils/cpf_validator'
import { ContactClientCreateComponent } from '../../contact/contact-client-create/contact-client-create.component'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { CreateDriverModel } from '../../../core/models/driver.model'
import { ContactClientEditComponent } from '../../contact/contact-client-edit/contact-client-edit.component'
import {NgIf} from '@angular/common'
import {HealthUnitService} from '../../../core/services/health-unit/location/health-unit.service'
import {AdminService} from '../../../core/services/admin/admin.service'
import {MunicipalityService} from '../../../core/services/municipality/municipality/municipality.service'

@Component({
  selector: 'admin-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatOption,
    MatSelect,
    MatDividerModule,
    NgxMaskDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSlideToggle,
    ContactClientEditComponent,
    NgIf,
  ],
  templateUrl: './admin-edit.component.html',
  styleUrl: './admin-edit.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    HabitsService,
    AddressTypeService,
  ],
  standalone: true,
})
export class AdminEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private viaCepService: ViaCepService,
    private employeeStatusService: EmployeeStatusService,
    private adminService: AdminService,
    private addressTypeService: AddressTypeService,
    private locationService: HealthUnitService,
    private municipalityService: MunicipalityService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<AdminEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
    this.minDate = today
  }

  item: any = {}

  @Output() responseEdit = new EventEmitter()
  @ViewChild('birth') datepickerBirth: MatDatepicker<any> | undefined
  @ViewChild('hiring') datepickerHiring: MatDatepicker<any> | undefined
  @ViewChild('validity') datepickerValidity: MatDatepicker<any> | undefined

  formEmployee: FormGroup = new FormGroup({})
  maxDate!: Date
  minDate!: Date

  loading: boolean = false
  listPessoas: any[] = []
  listUnidades: any[] = []
  listaMunicipios: any[] = []
  tipoPessoa: number = 0
  listSpecialty: any[] = []
  listAddressType: any[] = []
  listStatusEmployee: any[] = []
  listTypeDriver: any[] = []
  isSelectHealthUnitActive: boolean = false
  listCategory: any[] = [
    { id: 'A', description: 'A' },
    { id: 'B', description: 'B' },
    { id: 'C', description: 'C' },
    { id: 'D', description: 'D' },
    { id: 'E', description: 'E' },
  ]

  contactList: any[] = []
  fileList: any[] = []

  ngOnInit(): void {
    console.log("iniciou no local Correto!")
    this.createForm()
    this.listPessoasCreate()
    this.getMunicipio()
    this.formEmployee.get('typePerson')?.valueChanges.subscribe(value => {
      this.tipoPessoa = value
    })
  }

  listPessoasCreate(){
    this.listPessoas = [{id: 1, descricao: "Pessoa Física"},{id: 2, descricao: "Pessoa Jurídica"}]
  }

  close() {
    this.dialogRef.close()
  }

  getMunicipio(){
    this.municipalityService.listActiveMunicipality().subscribe({
      next: (response: any) => {
        if(response.data){
          this.listaMunicipios = response.data
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
        this.fillForm(this.item)
      }
    })
  }

  onMunicipioChange() {
    const municipioId = this.formEmployee.get('municipality')?.value

    this.formEmployee.get("healthUnit")?.reset()

    if (municipioId !== 0) {
      this.isSelectHealthUnitActive = true
      this.formEmployee.get('healthUnit')?.enable()
      this.getUnidadesDeSaude(municipioId)
    } else {
      this.isSelectHealthUnitActive = false
      this.formEmployee.get('healthUnit')?.disable()
    }
  }

  getUnidadesDeSaude(idMunicip: number | null = null) {
    this.loading = true
    if(idMunicip == null){
      this.locationService.listActiveLocation().subscribe({
        next: (response: ResponseRequestModel) => {
          this.listUnidades = response.data
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
        },
      })
    } else {
      this.locationService.listActiveLocationByMunicip(idMunicip).subscribe({
        next: (response: ResponseRequestModel) => {
          this.listUnidades = response.data
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
        },
      })
    }
  }

  createModel() {
    const tipoPessoa = this.formEmployee.get('typePerson')?.value

    const comum = {
      id: this.item.id,
      perfil_id: 1,
      id_tipo_pessoa: tipoPessoa,
      unidadeId: this.formEmployee.get('healthUnit')?.value,

      email: this.formEmployee.get('email')?.value,
      senha: this.formEmployee.get('password')?.value === '•••••••••' ? null : this.formEmployee.get('password')?.value,

      telefone_1: this.formEmployee.get('phone')?.value,
      telefone_whatsapp:
        this.formEmployee.get('telefone_whatsapp')?.value ||
        this.formEmployee.get('phone')?.value,
      observacao: this.formEmployee.get('observacao')?.value || '',

      logradouro: this.formEmployee.get('street')?.value,
      numero: this.formEmployee.get('number')?.value,
      bairro: this.formEmployee.get('neighborhood')?.value,
      cidade: this.formEmployee.get('city')?.value,
      cep: this.formEmployee.get('postalCode')?.value,
      estado: (this.formEmployee.get('state')?.value || '').toUpperCase(),
    }

    if (tipoPessoa === 1) {
      return {
        ...comum,
        cpf: this.formEmployee.get('cpf')?.value,
        rg: this.formEmployee.get('rg')?.value,
        genero: this.formEmployee.get('sex')?.value,
        data_nascimento: this.formEmployee.get('birth')?.value
          ? moment(this.formEmployee.get('birth')?.value).format('YYYY-MM-DD')
          : null,
        nomeCompleto: this.formEmployee.get('name')?.value,
        estado_civil: this.formEmployee.get('maritalStatus')?.value,
      }
    }

    if (tipoPessoa === 2) {
      return {
        ...comum,
        nome_fantasia: this.formEmployee.get('fantasy_name')?.value,
        razao_social: this.formEmployee.get('corporate_name')?.value,
        cnpj: this.formEmployee.get('cnpj')?.value,
      }
    }

    return { ...comum }
  }

  createForm(): void {
    this.formEmployee = this.formBuilder.group({
      municipality: [null, [Validators.required]],
      healthUnit: [{ value: null, disabled: false }, [Validators.required]],
      typePerson: [null, [Validators.required]],
      email: ['', [Validators.required, emailValidator()]],
      password: ['•••••••••', [Validators.required]],
      phone: ['', [Validators.required]],
      telefone_whatsapp: ['', []],
      observacao: ['', []],

      street: ['', [Validators.required]],
      number: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      city: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      state: ['', [Validators.required]],

      name: ['', []],
      rg: ['', []],
      cpf: ['', []],
      sex: ['', []],
      birth: [null, []],
      maritalStatus: [null, []],

      fantasy_name: ['', []],
      corporate_name: ['', []],
      cnpj: ['', []],
    })
  }

  fillForm(item: any) {
    console.log(item, 'item')
    this.tipoPessoa = item.id_tipo_pessoa

    // Busca o município da unidade do item
    const municipioId = item.municipio_id;

    this.formEmployee.patchValue({
      email: item.email,
      phone: item.telefone_1,
      telefone_whatsapp: item.telefone_whatsapp,
      observacao: item.observacao,

      street: item.endereco.logradouro,
      number: item.endereco.numero,
      neighborhood: item.endereco.bairro,
      city: item.endereco.cidade,
      postalCode: item.endereco.cep,
      state: item.endereco.estado,
      municipality: municipioId,
      typePerson: item.id_tipo_pessoa,
    })

    // Habilita e carrega unidades se houver município
    if (municipioId) {
      this.isSelectHealthUnitActive = true
      this.formEmployee.get('healthUnit')?.enable()
      this.getUnidadesDeSaude(municipioId)
      setTimeout(() => {
        this.formEmployee.patchValue({
          healthUnit: item.id_unidade
        })
      }, 500)
    }

    if (item.id_tipo_pessoa === 1) {
      this.formEmployee.patchValue({
        name: item.dados_pessoa.nomeCompleto,
        rg: item.dados_pessoa.rg,
        cpf: item.dados_pessoa.cpf,
        sex: item.dados_pessoa.genero,
        maritalStatus: Number(item.dados_pessoa.estado_civil),
        birth: item.dados_pessoa.data_nascimento
          ? moment(item.dados_pessoa.data_nascimento, 'YYYY-MM-DD').toDate()
          : null,
      })
    }

    if (item.id_tipo_pessoa === 2) {
      this.formEmployee.patchValue({
        fantasy_name: item.dados_pessoa.nome_fantasia,
        corporate_name: item.dados_pessoa.razao_social,
        cnpj: item.dados_pessoa.cnpj,
      })
    }
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.formEmployee.get('street')?.setValue('')
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('neighborhood')?.setValue('')
      this.formEmployee.get('city')?.setValue('')
      this.formEmployee.get('state')?.setValue('')
    } else {
      this.formEmployee.get('street')?.setValue(element.logradouro)
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('neighborhood')?.setValue(element.bairro)
      this.formEmployee.get('city')?.setValue(element.localidade)
      this.formEmployee.get('state')?.setValue(element.estado)
    }
  }

  getAddressByPostalCode() {
    let postalCode = this.formEmployee.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    }
  }

  getList(list: any[], type: 'contact' | 'file') {
    switch (type) {
      case 'contact':
        this.contactList = list
        break
      case 'file':
        this.fileList = list
        break
    }
  }

  editDriver() {
    this.loading = true
    this.adminService.editAdmin(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.loading = false
        this.snackbar.success(response.message)
        this.responseEdit.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  openDatepicker(datePicker: 'hiring' | 'birth' | 'validity') {
    if (this.datepickerBirth && datePicker == 'birth') {
      this.datepickerBirth.open()
    }
    if (this.datepickerHiring && datePicker == 'hiring') {
      this.datepickerHiring.open()
    }
    if (this.datepickerValidity && datePicker == 'validity') {
      this.datepickerValidity.open()
    }
  }

  checkForm() {
    if (this.formEmployee.valid) {
      return true
    } else {
      return false
    }
  }
}
